var map = {
	"./amplify-amazon-button_5.entry.js": [
		1362,
		20
	],
	"./amplify-auth-fields_9.entry.js": [
		1363,
		21
	],
	"./amplify-authenticator.entry.js": [
		1364,
		7
	],
	"./amplify-button_3.entry.js": [
		1365,
		22
	],
	"./amplify-chatbot.entry.js": [
		1366,
		6
	],
	"./amplify-checkbox.entry.js": [
		1367,
		23
	],
	"./amplify-confirm-sign-in_7.entry.js": [
		1368,
		8
	],
	"./amplify-container.entry.js": [
		1369,
		24
	],
	"./amplify-federated-buttons_2.entry.js": [
		1370,
		25
	],
	"./amplify-federated-sign-in.entry.js": [
		1371,
		26
	],
	"./amplify-form-field_4.entry.js": [
		1372,
		27
	],
	"./amplify-greetings.entry.js": [
		1373,
		28
	],
	"./amplify-icon-button.entry.js": [
		1374,
		29
	],
	"./amplify-icon.entry.js": [
		1375,
		9
	],
	"./amplify-link.entry.js": [
		1376,
		30
	],
	"./amplify-nav_2.entry.js": [
		1377,
		31
	],
	"./amplify-photo-picker.entry.js": [
		1378,
		32
	],
	"./amplify-picker.entry.js": [
		1379,
		33
	],
	"./amplify-radio-button_2.entry.js": [
		1380,
		10
	],
	"./amplify-s3-album.entry.js": [
		1381,
		11
	],
	"./amplify-s3-image-picker.entry.js": [
		1382,
		12
	],
	"./amplify-s3-image.entry.js": [
		1383,
		13
	],
	"./amplify-s3-text-picker.entry.js": [
		1384,
		14
	],
	"./amplify-s3-text.entry.js": [
		1385,
		15
	],
	"./amplify-select-mfa-type.entry.js": [
		1386,
		34
	],
	"./amplify-sign-in-button.entry.js": [
		1387,
		16
	],
	"./amplify-toast.entry.js": [
		1388,
		35
	],
	"./amplify-tooltip.entry.js": [
		1389,
		36
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1126;
module.exports = webpackAsyncContext;